<h1 class="title">{{'PASSWORD_RESET_SUCCESSFULLY' | translate}}</h1>

<p class="description">
    {{'PASSWORD_SUCCESS_MSG' | translate}}
</p>

<button class="btn primary form-btn" routerLink="/" mat-flat-button>{{'LOG_IN_TO_YOUR_ACCOUNT' | translate}}</button>